import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/lib/theme-chalk/index.css'
import { Editor } from '@tinymce/tinymce-vue'
import 'tinymce/tinymce'
import 'tinymce/icons/default'
import 'tinymce/themes/silver'
import 'tinymce/skins/ui/oxide/skin.min.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/main.css'
import './assets/styles/buttons.scss';

const app = createApp(App)

// 全局注册TinyMCE Editor组件
app.component('TinyEditor', Editor)

app.use(store)
app.use(router)
app.use(ElementPlus)

// 应用启动时恢复认证状态
const initAuth = async () => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token')
  if (token) {
    console.log('发现存储的token，尝试恢复认证...')
    try {
      await store.dispatch('auth/verifyToken', token)
      console.log('认证恢复成功')
    } catch (error) {
      console.error('认证恢复失败:', error)
      // 清除无效token
      localStorage.removeItem('token')
      sessionStorage.removeItem('token')
    }
  }
}

// 初始化认证后挂载应用
initAuth().finally(() => {
  app.mount('#app')
})